import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {
    amountDataTableTemplate,
    numberWithCommaDataTableTemplate, numberWithoutCommaDataTableTemplate, priceDataTableTemplate, rateDataTableTemplate
} from "../../../../utils/formatters/Numbers";
import {Dialog} from "primereact/dialog";
import {InputTextarea} from "primereact/inputtextarea";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import LoadingOverlay from 'react-loading-overlay';
import PropTypes from "prop-types";

const BilateralMoveTitleCollateral = ({...props}) => {
    return (
        <React.Fragment>
            <LoadingOverlay
                active={props.isLoading}
                spinner
                text='Loading...'>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TitlePage title={"Tablero de Control \\ " + props.action}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid item>
                                <Button
                                    label="Aceptar"
                                    style={{'float': 'right'}}
                                    onClick={props.handleAgree}/>
                            </Grid>
                            <Grid item>
                                <Button
                                    label="Rechazar"
                                    style={{'float': 'right'}}
                                    className="p-button-secondary"
                                    onClick={props.showRejectDialog}/>
                            </Grid>
                            <Grid item>
                                <Button
                                    label="Regresar"
                                    style={{'float': 'right'}}
                                    className="p-button-secondary"
                                    onClick={props.handleReturnButton}/>
                            </Grid>
                        </Grid>
                        {
                            props.showCollateralTable &&
                            <div>
                                <Grid item xs={12}>
                                    <Divider/>
                                </Grid>
                                <Grid item xs={12}>
                                    <SubtitleLabel header="Garantías" isBold={true}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <DataTable
                                        value={props.loanInstructionsCollateral}
                                        resizableColumns={true}
                                        columnResizeMode={"fit"}>
                                        <Column field="settlementFolio" header="Folio"
                                                style={{textAlign: 'left'}}
                                                editor={props.folioGuaranteeEditor} sortable={true}
                                                body={numberWithoutCommaDataTableTemplate}/>
                                        <Column field="composeName" header="Emisora"
                                                style={{textAlign: 'left'}} sortable={true}/>
                                        <Column field="titles" header="Títulos"
                                                body={numberWithCommaDataTableTemplate} sortable={true}/>
                                        <Column field="price" header="Precio Mercado"
                                                body={priceDataTableTemplate} sortable={true}/>
                                        <Column field="amount" header="Importe Mercado"
                                                body={amountDataTableTemplate} sortable={true}/>
                                    </DataTable>
                                </Grid>
                            </div>
                        }
                        {
                            props.showTitleTable &&
                            <div>
                                <Grid item xs={12}>
                                    <br/>
                                    <Divider/>
                                </Grid>
                                <Grid item xs={12}>
                                    <SubtitleLabel header="Títulos en Préstamo" isBold={true}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <DataTable
                                        value={props.loanInstructionsTitle}
                                        resizableColumns={true}
                                        columnResizeMode={"fit"}>
                                        <Column field="settlementFolio" header="Folio"
                                                style={{textAlign: 'left'}} body={numberWithoutCommaDataTableTemplate}
                                                editor={props.folioTitleEditor} sortable={true}/>
                                        <Column field="composeName" header="Emisora"
                                                style={{textAlign: 'left'}} sortable={true}/>
                                        <Column field="rate" header="Tasa"
                                                body={rateDataTableTemplate} sortable={true}/>
                                        <Column field="titles" header="Títulos"
                                                body={numberWithCommaDataTableTemplate} sortable={true}/>
                                        <Column field="price" header="Precio"
                                                body={priceDataTableTemplate} sortable={true}/>
                                        <Column field="amount" header="Importe"
                                                body={amountDataTableTemplate} sortable={true}/>
                                    </DataTable>
                                </Grid>
                            </div>
                        }
                        {
                            props.showPremiumTable  &&
                            <div>
                                <Grid item xs={12}>
                                    <br/>
                                    <Divider/>
                                </Grid>
                                <Grid item xs={12}>
                                    <SubtitleLabel header="Premio" isBold={true}/>
                                </Grid>
                                <Grid item xs={12}>
                                    <DataTable
                                        value={props.loanInstructionsPremium}
                                        resizableColumns={true}
                                        columnResizeMode={"fit"}>
                                        <Column field="settlementFolio" header="Folio"
                                                style={{textAlign: 'left'}} body={numberWithoutCommaDataTableTemplate}
                                                editor={props.folioPremiumEditor} sortable={true}/>
                                        <Column field="amount" header="Premio"
                                                body={amountDataTableTemplate} sortable={true}/>
                                    </DataTable>
                                </Grid>
                            </div>
                        }
                    </Grid>
                </Paper>
            </LoadingOverlay>

            <Dialog visible={props.displayDialog} modal={true} style={{width: "45%"}}
                    header={
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-6 p-lg-8" style={{padding: '.1em'}}>
                                <h2 className={"secondary-text"}>Rechazar</h2>
                            </div>
                            <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                                <Button label="Regresar" onClick={props.onHideDialog}
                                        className="p-button-secondary"/>
                            </div>
                            <div className="p-col-12 p-md-3 p-lg-2" style={{padding: '.2em'}}>
                                <Button label="Guardar" onClick={props.handleRefuse}/>
                            </div>
                        </div>}
                    onHide={props.onHideDialog} closable={false}>
                <div className="p-grid p-fluid">
                    <div className="p-col-12">
                        <SubtitleLabel header="Indique el motivo de rechazo" isBold={true}/>
                        <InputTextarea name="rejectMessage" rows={5} cols={30} autoResize={true}
                                       value={props.rejectMessage} onChange={props.saveMessage}/>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
};

export default BilateralMoveTitleCollateral;

BilateralMoveTitleCollateral.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    messagesGrowl: PropTypes.object.isRequired,
    handleAgree: PropTypes.func.isRequired,
    showRejectDialog: PropTypes.func.isRequired,
    handleReturnButton: PropTypes.func.isRequired,
    loanInstructionsCollateral: PropTypes.array.isRequired,
    loanInstructionsTitle: PropTypes.array.isRequired,
    loanInstructionsPremium: PropTypes.array.isRequired,
    folioGuaranteeEditor: PropTypes.object.isRequired,
    folioTitleEditor: PropTypes.object.isRequired,
    folioPremiumEditor: PropTypes.object.isRequired,
    displayDialog: PropTypes.bool.isRequired,
    onHideDialog: PropTypes.func.isRequired,
    rejectMessage: PropTypes.string,
    saveMessage: PropTypes.func.isRequired,
    showCollateralTable: PropTypes.bool.isRequired,
    showTitleTable: PropTypes.bool.isRequired,
    showPremiumTable: PropTypes.bool.isRequired,
    action: PropTypes.string.isRequired,
    handleRefuse: PropTypes.func.isRequired,
};